/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateDraftOfPaymentRequestsRequestSupplier
 */
export interface CreateDraftOfPaymentRequestsRequestSupplier {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'accountType': CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftOfPaymentRequestsRequestSupplier
     */
    'companyName': string | null;
}

export const CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum = typeof CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum[keyof typeof CreateDraftOfPaymentRequestsRequestSupplierAccountTypeEnum];


